<div *ngIf="isOffline" class="offline-banner">
    <span>You are offline. Some features may not work.</span>
</div>